<template>
  <div>
    <yplhxplb />
  </div>
</template>

<script>
// 获取接口地址
import yplhxplb from '@/components/yplyzdhxphc/yplhxplb'
export default {
  name: 'Yplyzdhxphc',
  components: {
    // sideMenu,
    // Header,
    yplhxplb
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
